import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { annualReviewSalesDepositsEditModeQueryOptions } from '~bank-annual-review/service'

export const annualReviewSalesDepositsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: routes.bank.annualReview.salesDepositsOnRoute,
    loader: ({ cause, params, context }) => {
      const id = Number(params.id)
      if (cause === 'stay') {
        return context.queryClient.getQueryData(['annual-review-sales-deposits-edit-mode', id]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(
        annualReviewSalesDepositsEditModeQueryOptions(id)
      )
    },
    component: lazyRouteComponent(() => import('./AnnualReviewSalesDeposits'))
  })
